import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { AmministrazioneTrasparente } from '../../shared/interface';

@Component({
  selector: 'app-amministrazione-trasparente',
  templateUrl: './amministrazione-trasparente.component.html',
  styleUrl: './amministrazione-trasparente.component.css'
})
export class AmministrazioneTrasparenteComponent implements OnInit {

  constructor(private apiService: ApiService) { }

  files: AmministrazioneTrasparente[] = []

  ngOnInit(): void {   
    this.apiService.getFilesAmministrazioneTrasparente().subscribe({
      next: (data) => this.files = [...data],
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => { }
    })
  }
}
